import { useEffect } from "react";
import { UseAutocompleteState } from "./useAutocomplete";
import { TagItem } from "./tagItem";

export const useNoResultsTracking = (
  noResults: boolean,
  tags: TagItem[],
  autocompleteState: UseAutocompleteState
) => {
  const isOpen = autocompleteState.isOpen;
  const query = autocompleteState.query;

  useEffect(() => {
    if (noResults && isOpen && query) {
      // console.log("No results", query, tags);
      window.wspr?.P("where-to-go:no-results", { tags, query });
    }
  }, [noResults, tags, query, isOpen]);
};

export const addTagTracking = (tag: TagItem) => {
  // console.log("ADD TAG", tag, window.wspr);
  window.wspr?.P("where-to-go:add-tag", { tag });
};

export const removeTagTracking = (tag: TagItem) => {
  // console.log("REMOVE TAG", tag, window.wspr);
  window.wspr?.P("where-to-go:remove-tag", { tag });
};
